import { render, staticRenderFns } from "./KaoguanMemberList.vue?vue&type=template&id=12b5e15f&scoped=true&"
import script from "./KaoguanMemberList.vue?vue&type=script&lang=js&"
export * from "./KaoguanMemberList.vue?vue&type=script&lang=js&"
import style0 from "./KaoguanMemberList.vue?vue&type=style&index=0&id=12b5e15f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b5e15f",
  null
  
)

export default component.exports